import { render, staticRenderFns } from "./ListTableLogs.vue?vue&type=template&id=1a9a3c1f&scoped=true&lang=pug"
import script from "./ListTableLogs.vue?vue&type=script&lang=js"
export * from "./ListTableLogs.vue?vue&type=script&lang=js"
import style0 from "./ListTableLogs.vue?vue&type=style&index=0&id=1a9a3c1f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a3c1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a9a3c1f')) {
      api.createRecord('1a9a3c1f', component.options)
    } else {
      api.reload('1a9a3c1f', component.options)
    }
    module.hot.accept("./ListTableLogs.vue?vue&type=template&id=1a9a3c1f&scoped=true&lang=pug", function () {
      api.rerender('1a9a3c1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ListTableLogs.vue"
export default component.exports